import Cookies from "js-cookie";
import router from "../router";

import axios from "axios";
import { getBaseUrl } from "../helper/constant";

export async function login(username, password) {
  try {
    const response = await axios.post(getBaseUrl() + `/auth/login`, {
      username: username,
      password: password,
    });
    if (response.status == 200 || response.status == 201) {
      Cookies.set("userToken", response.data.accessToken, {
        expires: 1,
        secure: true,
      });
      router.push("/content");
    }
  } catch (ee) {
    return false;
  }
}
export async function logout() {
  Cookies.remove("userToken");
  router.push("/login");
}
export function isUserActive() {
  return Cookies.get("userToken") ? true : false;
}
